<script>
import appConfig from "@/app.config";
import { mapGetters } from "vuex";
import {
  isCacheListSchedulesByCarManager,
  isCacheListSchedulesBySale,
} from '@/helpers/cache';
export default {
  name: "app",
  page: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  data() {
    return {
      includeRouteCache: ['ListSchedulesByCarManager','ListSchedulesBySale'],
    }
  },
  created() {
    if (
      ! Object.keys(this.options_tables).length &&
      Object.keys(this.user).length
    ) {
      console.log("created | $store.dispatch");
      this.$store.dispatch('permissions/getPermissions');
      this.$store.dispatch('options/getOptionsTable');
      this.$store.dispatch('options/getSystemCodes');
      this.$store.dispatch('options/getOwnVendorSites');
    }
  },
  watch: {
    user: {
      handler(value) {
        if (!value) {
          console.log('value(user)なし');
          return;
        }
        // console.log("watch user handler value: " + JSON.stringify(value));
        if (
          ! Object.keys(this.options_tables).length &&
          Object.keys(value).length
        ) {
          console.log("watch user handler | $store.dispatch");
          this.$store.dispatch('permissions/getPermissions');
          this.$store.dispatch('options/getOptionsTable');
        }
      },
    },
    $route(to) {
      if (isCacheListSchedulesByCarManager(to.name)) {
        this.includeRouteCache = ['ListSchedulesByCarManager'];
      } else if (isCacheListSchedulesBySale(to.name)) {
        this.includeRouteCache = ['ListSchedulesBySale'];
      } else {
        this.clearCache();
      }
    },
  },
  computed: {
    ...mapGetters("options", ["options_tables"]),
    ...mapGetters("auth", ["user"]),
    isLoading() {
      return this.$store.state.isShowLoading;
    },
  },
  methods: {
    clearCache() {
      this.includeRouteCache = [];
    },
  }
}
</script>

<template>
  <b-overlay
    :show="isLoading"
    rounded
    opacity="0.6"
    spinner-small
    spinner-variant="primary"
    style="min-height: 100vh;"
  >
    <div id="app">
      <keep-alive
        :include="includeRouteCache"
        max="2"
      >
        <RouterView :key="$route.fullPath" />
      </keep-alive>
    </div>
  </b-overlay>
</template>

